import { Card, SimpleCollapse } from 'components'
import { COLORS, SPACING } from 'utils'

import { Sector, /*ContractTypeSap*/ } from './components'

export default function Contract() {
  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
    {/*
      <SimpleCollapse title="Tipo Contrato SAP">
        <ContractTypeSap />
      </SimpleCollapse>
    */}
      <SimpleCollapse title="Negócios">
        <Sector />
      </SimpleCollapse>
    </Card>
  )
}
